// extracted by mini-css-extract-plugin
export default {"section":"section-Okkxb","label":"label-N9piy","ssoLinksContainer":"ssoLinksContainer-dmBBl","formElement":"formElement-SjY0C","dropdown":"dropdown-vDs54"};